module.exports = __webpack_public_path__ + "static/media/LinotteRegular.03d6c476.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Linotte/LinotteRegular.otf
// module id = 238
// module chunks = 0